import { IEconomicCalendarDto } from "@/components/Footer/components/Toolbar/EconomicCalendar/api/economicCalendarApi";
import { ImpactLevels } from "@/components/Footer/components/Toolbar/EconomicCalendar/ui/ImpactLevelSelect";

export interface IEconomicCalendarState {
    data: Record<string, IEconomicCalendarDto[]>;
    countries: {
        icon: string;
        label: string;
    }[];
    selectedCountry: string;
    selectedImpactLevel: ImpactLevels;
}

const initialState: IEconomicCalendarState = {
    data: null,
    countries: [],
    selectedCountry: "USA",
    selectedImpactLevel: ImpactLevels.Any,
};

export enum EconomicCalendarActionTypes {
    SET_DATA = "economicCalendar/SET_DATA",
    SET_COUNTRIES = "economicCalendar/SET_COUNTRIES",
    SET_SELECTED_COUNTRY = "economicCalendar/SET_SELECTED_COUNTRY",
    SET_SELECTED_IMPACT_LEVEL = "economicCalendar/SET_SELECTED_IMPACT_LEVEL",
}

export interface ISetDataAction {
    type: typeof EconomicCalendarActionTypes.SET_DATA;
    data: Record<string, IEconomicCalendarDto[]>;
}

export interface ISetCountriesAction {
    type: typeof EconomicCalendarActionTypes.SET_COUNTRIES;
    countries: {
        icon: string;
        label: string;
    }[];
}

export interface ISetSelectedCountryAction {
    type: typeof EconomicCalendarActionTypes.SET_SELECTED_COUNTRY;
    selectedCountry: string;
}

export interface ISetSelectedImpactLevelAction {
    type: typeof EconomicCalendarActionTypes.SET_SELECTED_IMPACT_LEVEL;
    selectedImpactLevel: ImpactLevels;
}

export type EconomicCalendarActions =
    | ISetDataAction
    | ISetCountriesAction
    | ISetSelectedCountryAction
    | ISetSelectedImpactLevelAction;

export const economicCalendarReducer = (
    state = initialState,
    action: EconomicCalendarActions
): IEconomicCalendarState => {
    const { type } = action;

    switch (type) {
        case EconomicCalendarActionTypes.SET_DATA: {
            const { data } = action as ISetDataAction;

            return {
                ...state,
                data,
            };
        }
        case EconomicCalendarActionTypes.SET_COUNTRIES: {
            const { countries } = action as ISetCountriesAction;

            return {
                ...state,
                countries,
            };
        }
        case EconomicCalendarActionTypes.SET_SELECTED_COUNTRY: {
            const { selectedCountry } = action as ISetSelectedCountryAction;

            return {
                ...state,
                selectedCountry,
            };
        }
        case EconomicCalendarActionTypes.SET_SELECTED_IMPACT_LEVEL: {
            const { selectedImpactLevel } = action as ISetSelectedImpactLevelAction;

            return {
                ...state,
                selectedImpactLevel,
            };
        }
        default:
            return state;
    }
};
